<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>打卡记录查询&nbsp;&nbsp;说明::<br>
					<span class="red">1、非管理员只能看到自己的流水。</span><br>
					<span>2、流水记录只提供查询和导出。</span><br>
				</h5>
			</div>
		</div>
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

		</pre-base>

	</div>
</template>

<script>
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: ''

			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {

			loaddata: function() {
				/*
				直接初始化好文件上传的关键字
				*/
				this.load_url = api.http_method;
				this.load_json = Select_PageLength('data_exp_record', this.nowpage, this.page_length);

				this.fun_load_dep();
				this.fun_load_user();

			},
			fun_init() {
				// let t_list_department = [],

				this.init_data = '';
				this.init_data = JSON.stringify({
					"control": "control_record",
					"isTwo": "0",
					"isTwoDetail": "1",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"show_tan_edit": "0",
					"sel_action": 'exp_record',
					"upd_action": '',
					"detail_part": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "姓名",
							"val": "",
							"key": "user_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel": "1"
						},
						{
							"name": "部门",
							"val": "",
							"key": "user_dep",
							"type": "select",
							"class": "long1",
							"sel_action": "data_dep",
							"sel_name": "",
							"sel": "2"
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "截至日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"sel": "4"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"sel": "8"
						},
					],
					"parm": [],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "员工姓名"
						},
						{
							"name": "打卡地点",
							"class": "long3"
						},
						{
							"name": "打卡坐标"
						},
						{
							"name": "网络状态"
						},
						{
							"name": "备注"
						},
						{
							"name": "附件"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [],
					"d_name": []
				});

			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_children: function(type, id, val) {
				this.$message({
					message: '类别=!' + type + ' 没有配置相关操作!',
					type: 'error'
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},


		}

	};
</script>
<style scoped>
	
</style>